/**
 * API Endpoints Configuration
 * Centralized endpoint definitions for the application
 */

// Base API paths
export const API_BASE = {
  ACCOUNTING: '/api/Accounting',
  VIOLATION: '/api/Violation',
  CONTACT: '/api/Contact',
};

// Authentication endpoints
export const AUTH_ENDPOINTS = {
  LOGIN: `${API_BASE.ACCOUNTING}/Login`,
  AUTO_LOGIN: `${API_BASE.ACCOUNTING}/AutoLogin`,
};

// Violation endpoints
export const VIOLATION_ENDPOINTS = {
  GET_VIOLATION: `${API_BASE.VIOLATION}/Violation`,
  CHECK: (ticketNumber, licensePlate) =>
    `${API_BASE.VIOLATION}/Check/${ticketNumber}/${licensePlate}`,
  GET_IMAGES: (ticketNumber, imageIndex, mediaSelector = 2) =>
    `${API_BASE.VIOLATION}/GetImages/${ticketNumber}/${imageIndex}?mediaSelector=${mediaSelector}`,
  SEND_MAIL: `${API_BASE.VIOLATION}/SendMail`,
};

// Contact endpoints
export const CONTACT_ENDPOINTS = {
  GET_FORM_DATA: `${API_BASE.CONTACT}/GetContactFormData`,
  SEND_EMAIL: `${API_BASE.CONTACT}/SendEmail`,
};

// Media selector types
export const MEDIA_SELECTOR = {
  THUMBNAIL: 1,
  FULL_IMAGE: 2,
};

///this is a post api/violation/Check/{ticketNumber}/{licensePlate}